import { render } from "./Vipini.vue?vue&type=template&id=0f9026d1"
import script from "./Vipini.vue?vue&type=script&lang=js"
export * from "./Vipini.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__